module.exports = __webpack_public_path__ + "img/greet_eye.7bdcda60.png";